export enum COVER_SEARCH_VARIANT {
  DEFAULT = 'default',
  EVENT = 'event',
}
